import { takeEvery, takeLeading, delay, call, put } from "redux-saga/effects";
import { SHOW_TOAST } from "constants/actionTypes";
import * as toastActions from "actions/toaster";
import Toaster from "components/Common/Toaster";
import { patterns as rulePatterns } from "actions/account/rules";
import { patterns as flowPatterns } from "actions/account/flows";
import { USER_REMOVED } from "constants/account/users";

export function* showToast({ payload: { toastProps } }) {
  yield call([Toaster, Toaster.show], toastProps);
}

export function* showDelayedToast(toastProps, delayMs) {
  yield delay(delayMs);
  yield put(toastActions.showToast(toastProps));
}

export function* showFlushToast() {
  yield call(
    showToast,
    toastActions.showToast({ message: "Changes saved", type: "success" })
  );
}

export function* showUserRemovedToast() {
  yield call(
    showToast,
    toastActions.showToast({
      message: "User removed successfully",
      type: "success"
    })
  );
}

function* toaster() {
  yield takeEvery(SHOW_TOAST, showToast);
  yield takeLeading([rulePatterns.flush, flowPatterns.flush], showFlushToast);
  yield takeLeading(USER_REMOVED, showUserRemovedToast);
}

export default toaster;
